
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { startCase } from 'lodash';
import MainMenu from './components/MainMenu/MainMenu.vue';
import { Notification } from '@/types/notifications';
import { fas } from '@fortawesome/pro-solid-svg-icons';

@Component({
  components: { MainMenu },
})
export default class App extends Vue {
  @Action('notifications/shiftNotification') shiftNotification!: Function;
  @Getter('notifications/notificationQueue') NotificationQueue!: Notification[];
  @Getter('notifications/notificationsPending') NotificationsPending!: number;
  @Getter('user/authenticated') authenticated!: boolean;
  @Mutation('notifications/setReloadNotification')
  setReloadNotification!: Function;

  show: boolean = false;

  notification: Notification = {
    text: null,
    colour: null,
    top: false,
    bottom: false,
    left: false,
    right: false,
    timeout: 6000,
  };

  get pageName() {
    const name = this.$route.name || undefined;
    return startCase(name);
  }

  get showReloadNotification(): boolean {
    return this.$store.state.notifications.showReload;
  }

  set showReloadNotification(value: boolean) {
    this.setReloadNotification(value);
  }

  reloadPage(): void {
    window.location.reload();
  }

  updateNotification() {
    if (!this.show && this.NotificationsPending) {
      this.notification = this.NotificationQueue[0];
      this.shiftNotification();

      this.$nextTick(() => {
        this.show = true;
      });
    }
  }

  @Watch('NotificationQueue')
  onNotificationQueueChanged() {
    this.updateNotification();
  }

  @Watch('show')
  onShowChanged() {
    this.updateNotification();
  }
}
